import Model, { attr, belongsTo } from "@ember-data/model";
import { tKey } from "ember-intl";

export default class ServerStatusModel extends Model {
  @attr cpuusage;
  @attr memoryusage;
  @attr diskusage;
  @attr status;
  @attr isRunning;
  @attr isSuspended;
  @attr isLocked;

  get isStopped() {
    return !this.isRunning;
  }

  get statusIndicator() {
    if (this.isLocked) {
      return { state: "busy", labelKey: tKey("label.locked") };
    }

    if (this.isRunning === undefined) {
      return { state: "offline", labelKey: tKey("label.loading") };
    }

    return this.isRunning
      ? { state: "online", labelKey: tKey("label.online") }
      : { state: "error", labelKey: tKey("label.offline") };
  }

  @belongsTo("server", { async: false, inverse: "status" }) server;
}
